export const BUSINESS_REFUND_SETTINGS_QUERY_KEY = 'businessRefundSettings'
